export default "<p>billing works!</p>\n";